/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type AckGooseGameDashboardCatchUpMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type AckGooseGameDashboardCatchUpMutation = {
  ackGooseGameDashboardCatchUp: Pick<Types.Success, "status">;
};

export const AckGooseGameDashboardCatchUpDocument = gql`
  mutation AckGooseGameDashboardCatchUp {
    ackGooseGameDashboardCatchUp {
      status
    }
  }
`;

/**
 * __useAckGooseGameDashboardCatchUpMutation__
 *
 * To run a mutation, you first call `useAckGooseGameDashboardCatchUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAckGooseGameDashboardCatchUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ackGooseGameDashboardCatchUpMutation, { data, loading, error }] = useAckGooseGameDashboardCatchUpMutation({
 *   variables: {
 *   },
 * });
 */
export function useAckGooseGameDashboardCatchUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AckGooseGameDashboardCatchUpMutation,
    AckGooseGameDashboardCatchUpMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    AckGooseGameDashboardCatchUpMutation,
    AckGooseGameDashboardCatchUpMutationVariables
  >(AckGooseGameDashboardCatchUpDocument, baseOptions);
}
export type AckGooseGameDashboardCatchUpMutationHookResult = ReturnType<
  typeof useAckGooseGameDashboardCatchUpMutation
>;
export type AckGooseGameDashboardCatchUpMutationResult =
  ApolloReactCommon.MutationResult<AckGooseGameDashboardCatchUpMutation>;
export type AckGooseGameDashboardCatchUpMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AckGooseGameDashboardCatchUpMutation,
    AckGooseGameDashboardCatchUpMutationVariables
  >;
